<template>
    <div class="inbound-invoices-table">
        <base-table
            ref="baseTable"
            :checkbox="true"
            :headers="headers"
            :items="itens"
            :total-items="totalItens"
            :page="page"
            :page-size="size"
            :show-pagination="true"
            :results-label="translate('results')"
            :views-by-page-label="translate('views_by_page')"
            :empty-text="translate('no_data')"
            label-class-name="inbound-invoices-table__label"
            card-title="nomeArquivo"
            @selectionChange="onSelectionChange"
            @paginationChange="onPaginationChange"
        >
            <template #produtos="{ row }">
                <div>
                    <span v-if="row.produtos.length <= 1">
                        {{ translateProduto(row.produtos[0]) }}
                    </span>
                    <div v-else>
                        <span>{{ translateProduto(row.produtos[0]) }}</span>
                        <el-popover
                            placement="top-start"
                            :width="200"
                            :title="translate('col_product')"
                            trigger="hover"
                        >
                            <template #reference>
                                <el-tag class="ml-2" size="mini">
                                    {{ row.produtos.length }}
                                </el-tag>
                            </template>
                            <div>
                                <div
                                    v-for="produto in row.produtos"
                                    :key="produto"
                                    class="company-list-item"
                                >
                                    {{ translateProduto(produto) }}
                                </div>
                            </div>
                        </el-popover>
                    </div>
                </div>
            </template>

            <template #contratos="{ row }">
                <div>
                    <span v-if="row.contratos.length <= 1">
                        {{ row.contratos[0] }}
                    </span>
                    <div v-else>
                        <span>{{ row.contratos[0] }}</span>
                        <el-popover
                            placement="top-start"
                            :width="200"
                            :title="translate('col_contract')"
                            trigger="hover"
                        >
                            <template #reference>
                                <el-tag class="ml-2" size="mini">
                                    {{ row.contratos.length }}
                                </el-tag>
                            </template>
                            <div>
                                <div
                                    v-for="contrato in row.contratos"
                                    :key="contrato"
                                    class="company-list-item"
                                >
                                    {{ contrato }}
                                </div>
                            </div>
                        </el-popover>
                    </div>
                </div>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/BaseTable.vue';
import NotaEntradaService from '@/services/NotaEntradaService';
import { buildHeaders } from './headers';
import { translate, translateProduto } from './formatters';

export default {
    name: 'InboundInvoicesTable',
    components: {
        BaseTable
    },
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    data() {
        return {
            itens: [],
            page: 1,
            size: 10,
            totalItens: 0,
            selecionados: []
        };
    },
    computed: {
        headers() {
            return buildHeaders(this.$i18n.locale);
        }
    },
    mounted() {
        this.fetchNotasEntrada();
    },
    watch: {
        filters: {
            handler() {
                this.page = 1;
                this.fetchNotasEntrada();
            },
            deep: true
        }
    },
    methods: {
        translateProduto,
        onSelectionChange(linhas) {
            this.selecionados = linhas;
            this.$emit('selectionChange', linhas);
        },
        onPaginationChange(pagination) {
            if (pagination.pageSize !== this.size) {
                this.page = 1;
            } else {
                this.page = pagination.page;
            }
            this.size = pagination.pageSize;
            this.fetchNotasEntrada();
        },
        translate,
        async fetchNotasEntrada() {
            try {
                const body = {
                    filtroTexto: this.filters.filtroTexto || '',
                    dataInicio: this.filters.dataInicio || null,
                    dataFim: this.filters.dataFim || null
                };
                const { data } = await NotaEntradaService.listarNotasEntradaPaginado(
                    body,
                    this.page - 1,
                    this.size
                );
                this.itens = data.itens || [];
                this.totalItens = data.totalItens || 0;
            } catch (error) {
                this.$notify.error({
                    message: this.translate('error_fetching')
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
.inbound-invoices-table {
    margin-top: -8px;
}

::v-deep .inbound-invoices-table__label {
    word-break: keep-all !important;
}

.company-list-item {
    font-size: 11px;
}
</style>
